import { Box, MenuItem, Select } from '@mui/material'
import { FC, ReactElement } from 'react'
import { getValidCurrentStepIndex } from '../../FormHelpersConditions'
import { EditableFormIcon } from '../../FormStepper'

interface FormStepperDropdownProps {
  disabledIds?: string[]
  sections: any[]
  currentStep: number
  handleStepChange: (newIndex: number) => void
  renderStepLabel: (index: number, section: any) => JSX.Element
  disabled?: boolean
  renderIcons?: boolean
  parsedErrors?: any[]
  sectionToErrors?: Record<string, any>
}

const FormStepperDropdown: FC<FormStepperDropdownProps> = ({
  disabledIds,
  sections,
  currentStep,
  handleStepChange,
  renderStepLabel,
  disabled,
  renderIcons,
  parsedErrors,
  sectionToErrors
}) => {
  const selectValue: number = getValidCurrentStepIndex({
    realIndex: currentStep,
    disabledIds: disabledIds || []
  })

  const renderIcon = (section: any, index: number, isSmaller = false): ReactElement => {
    if (renderIcons === undefined || !renderIcons) {
      return <></>
    }

    const isError = parsedErrors?.some(obj => index === obj.sectionIndex) ??
      sectionToErrors?.[section.templateId]

    const iconProps = {
      active: section.trueIndex === selectValue,
      completed: true, // index < currentStep,
      error: renderIcons && isError
    }

    return (
      <Box
        sx={{
          marginRight: isSmaller ? '1px' : '5px',
          ...(isSmaller && { transform: 'scale(0.8)', transformOrigin: 'left center' }),
          display: 'flex',
          height: 'fit-content',
          width: 'fit-content'
        }}
      >
        <EditableFormIcon {...iconProps} />
      </Box>
    )
  }

  // Find the currently selected section to render in the select display
  const selectedSection = sections.find(section => section.trueIndex === selectValue)
  const selectedIndex = sections.findIndex(section => section.trueIndex === selectValue)

  return (
    <Select
      disabled={disabled}
      variant='outlined'
      value={selectValue ?? 0}
      onChange={e => {
        handleStepChange(Number(e.target.value))
      }}
      SelectDisplayProps={{
        id: 'form-stepper-dropdown'
      }}
      sx={{
        width: 270,
        maxWidth: 270,
        fontSize: 14,
        color: 'primary.main',
        '& .MuiSelect-select': {
          pt: '7.5px',
          pb: '7.5px'
        }
      }}
      renderValue={(value) => {
        if (selectedSection === undefined) return null

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {renderIcon(selectedSection, selectedIndex, true)}
            <Box
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {renderStepLabel(selectedIndex, selectedSection)}
            </Box>
          </Box>
        )
      }}
    >
      {sections.map((section, index) => (
        <MenuItem key={index} value={section.trueIndex}>
          {renderIcon(section, index)}
          {renderStepLabel(index, section)}
        </MenuItem>
      ))}
    </Select>
  )
}

export default FormStepperDropdown
